import axios from "axios";

import { PaymentSessionToken } from "redmond";
import {
  purchaseApi,
  PaymentOpaqueValue,
  AncillaryOpaqueValue,
} from "@b2bportal/purchase-api";

export const schedulePaymentV0 = ({
  token,
  payments,
  ancillaries = [],
  corporateOutOfPolicyReason,
  corporateTripDescription,
  channel,
}: {
  token: PaymentSessionToken;
  payments: Array<PaymentOpaqueValue>;
  ancillaries?: AncillaryOpaqueValue[];
  corporateOutOfPolicyReason?: string;
  corporateTripDescription?: string;
  channel: "TravelApp" | "Mobile" | "Web";
}): Promise<String> =>
  new Promise((resolve, reject) => {
    try {
      const res = purchaseApi(axios).apiV0PurchaseFulfillSchedulePost({
        quoteToken: {
          value: token.value,
        },
        payments,
        ancillaries,
        corporateOutOfPolicyReason,
        corporateTripDescription,
        channel,
      });

      res.then((body) => resolve(body.data.value)).catch((e) => reject(e));
    } catch (e) {
      reject(e);
    }
  });
